import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const namespaced = true;

const state = {
  detail: {},
  lastRefreshDate: null,
  classWarnings: [],
};

export default {
  namespaced,
  actions,
  getters,
  mutations,
  state,
};
